import React from "react";
import { cn } from "ui";

interface DataTableRenderIconProps {
  icon?: React.ReactNode | React.ComponentType<{ className?: string }>;
  destructive?: boolean;
}

export function DataTableRenderIcon(
  props: DataTableRenderIconProps,
): React.ReactNode {
  const Icon = props.icon;
  const className = cn("size-4", {
    "text-destructive": props.destructive,
  });

  if (!Icon) return null;

  if (
    typeof Icon === "function" ||
    (typeof Icon === "object" && "render" in Icon)
  ) {
    const Component = Icon as React.ComponentType<{ className?: string }>;
    return <Component className={className} />;
  }

  if (React.isValidElement(Icon)) {
    if (props.destructive) {
      return React.cloneElement(
        Icon as React.ReactElement<{ className?: string }>,
        {
          className: cn(
            (Icon as React.ReactElement<{ className?: string }>).props
              .className,
            "text-destructive",
          ),
        },
      );
    }

    return Icon;
  }

  return Icon as React.ReactNode;
}
